export default "__VITE_ASSET__b827abcf__"